import React from "react";
import "./index.scss";


const Card = ({title, className, children}) => (
    <div className={`card${className ? ' ' + className : ''}`}>
        <div className="card__top">
            <h6 className="card__title">{title || ''}</h6>
        </div>
        <div className="card__content">{children}</div>
    </div>
);

export default Card;